import {createTheme} from '@material-ui/core/styles';
import {red} from '@material-ui/core/colors';

// Create a theme instance.
export const theme = createTheme({
    palette: {
        primary: {
            main: '#556cd6',
        },
        secondary: {
            main: '#19857b',
        },
        error: {
            main: red.A400,
        },
        background: {
            default: '#fff',
        },
        action: {
            disabled: "#212121"
        }
    },
    overrides: {
        MuiAvatar: {
            img: {
                objectFit: 'contain',
            }
        }
    }
});
